// Module
var code = "<a href=\"javascript:;\" class=\"btn blue-dark subFormControl\"> <i class=\"fa fa-desktop\" align=\"center\"></i> <!-- ko text: _labels.CONSULT --><!-- /ko --> </a>";
// Exports
export default code;